
import { defineComponent } from 'vue'
import SideMenu from '@/views/components/SideMenu.vue'
import NavBar from '@/views/components/NavBar.vue'

export default defineComponent({
  components: {
    NavBar,
    SideMenu
  }
})
